<div *ngIf="displayBanner && showStickyPopup"
  class="client-banner-popup"
  [style.background-color]="getClientConfig().background"
  [style.color]="getClientConfig().foreground">
  {{getClientConfig().name}}
</div>

<portal-navbar id="portal-navbar">
  <div *ngIf="displayBanner"
    class="client-banner"
    [style.background-color]="getClientConfig().background"
    [style.color]="getClientConfig().foreground">
    {{getClientConfig().name}}
  </div>
  <nav class="portalnav">
  <div class="portalnav__title"></div>
  <div class="portalnav__content"></div>
  <span class='rebrand-logo'></span>
  <span class="inm-logo"></span>
  <div id="menuBar">
    <span id="inmar-logo-text-container" routerLink="" style="margin-bottom: 7px">
      <div class="inmar-logo-text"></div>
      <div class="inmar-logo-text inmar-logo-text-thin">{{apptitle}}</div>
    </span>
    <ul id="menuItems">
      <li *ngFor="let section of validSections">
        <a
          routerLinkActive="active"
          [routerLink]="section.path"
          [routerLinkActiveOptions]="{ exact: false }"
          >{{ section.name }}</a
        >
      </li>
    </ul>
  </div>
  <div *ngIf="clientsLoaded && usersClients.length > 1">
      <p-dropdown [options]="usersClients" [(ngModel)]="currentClient" (onChange)="clientSelected($event)" class="client-droplist"></p-dropdown>
  </div>
  <div *ngIf="clientsLoaded && usersClients.length === 1">
    <div><h4 class="client-label">{{usersClients[0]['label']}}</h4></div>
  </div>
</nav>
<div name="healthcareTopBar" id="healthcareTopBar"></div>

</portal-navbar>
